import { TReduxActions } from '../../../types/redux';
import { TIsAnonymous } from '../../../types/newReview';
import { ENewAnswerForm } from '../../../actions/newAnswer/newAnswearAction';
import { EAnonymousActionTypes } from '../../../actions/newAnswer/isAnonymousActions';

export const defaultValue = {
  value: null,
};

export function isAnonymousAnswerReducer(
  state: TIsAnonymous = defaultValue,
  { type, payload }: TReduxActions,
): TIsAnonymous {
  if (type === EAnonymousActionTypes.Set) {
    return {
      value: payload,
    };
  }

  if (type === ENewAnswerForm.Clear) {
    return defaultValue;
  }

  return state;
}
